// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Study } from './study';
import {
    StudyFromJSON,
    StudyFromJSONTyped,
    StudyToJSON,
    StudyToJSONTyped,
} from './study';

/**
 * 
 * @export
 * @interface DaeStudiesResponse
 */
export interface DaeStudiesResponse {
    /**
     * 
     * @type {number}
     * @memberof DaeStudiesResponse
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof DaeStudiesResponse
     */
    nextToken?: string;
    /**
     * 
     * @type {Array<Study>}
     * @memberof DaeStudiesResponse
     */
    studies: Array<Study>;
}

/**
 * Check if a given object implements the DaeStudiesResponse interface.
 */
export function instanceOfDaeStudiesResponse(value: object): value is DaeStudiesResponse {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('studies' in value) || value['studies'] === undefined) return false;
    return true;
}

export function DaeStudiesResponseFromJSON(json: any): DaeStudiesResponse {
    return DaeStudiesResponseFromJSONTyped(json, false);
}

export function DaeStudiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DaeStudiesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
        'studies': ((json['studies'] as Array<any>).map(StudyFromJSON)),
    };
}

export function DaeStudiesResponseToJSON(json: any): DaeStudiesResponse {
    return DaeStudiesResponseToJSONTyped(json, false);
}

export function DaeStudiesResponseToJSONTyped(value?: DaeStudiesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'nextToken': value['nextToken'],
        'studies': ((value['studies'] as Array<any>).map(StudyToJSON)),
    };
}
